import { createSlice } from '@reduxjs/toolkit';
import { extractSubdomain } from '@utils/subdomain';

const initialState = {
	isDiscordConnected: false,
	isBackendConnected: false,
	// app is connected if both discord and backend are connected
	isAppConnected: false,
	isAppDomain: extractSubdomain()
};

const appConnectionsSlice = createSlice({
	name: 'appConnections',
	initialState,
	reducers: {
		setDiscordConnected: (state, action) => {
			state.isDiscordConnected = action.payload;
			state.isAppConnected = state.isDiscordConnected && state.isBackendConnected;
		},
		setBackendConnected: (state, action) => {
			state.isBackendConnected = action.payload;
			state.isAppConnected = state.isDiscordConnected && state.isBackendConnected;
		},
		setAppDomain: (state, action) => {
			state.isAppDomain = action.payload;
		}
	}
});

export const { setDiscordConnected, setBackendConnected, setAppDomain } = appConnectionsSlice.actions;

export default appConnectionsSlice.reducer;
